// searchable-freesolo-auto-select.tsx
import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import Popper from "@mui/material/Popper";
import FormControl from "@mui/material/FormControl";
import { ErrorMessage } from "formik";
import Box from "@mui/material/Box";
import "./searchable-freesolo-auto-select.scss";
import {
  FreeSoloAutoSelectProps,
  OptionType,
} from "./searchable-auto-select-props";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomPopper = (props: any) => (
  <Popper
    {...props}
    placement="bottom-start"
    modifiers={[
      { name: "flip", enabled: false },
      {
        name: "preventOverflow",
        enabled: true,
        options: { boundary: "viewport" },
      },
    ]}
  />
);

const SearchableFreeSoloAutoSelect: React.FC<FreeSoloAutoSelectProps> = ({
  options,
  onChange,
  value,
  fieldName,
  placeholder,
  isShowError,
  handleBlur,
}) => {
  const getLabel = (option: string | OptionType): string => {
    if (typeof option === "string") return option;
    if (option.inputValue) return option.inputValue;
    return option[fieldName] || "";
  };

  const handleChange = (_: any, newValue: any) => {
    if (typeof newValue === "string") {
      onChange({ [fieldName]: newValue });
    } else if (newValue?.inputValue) {
      onChange({ [fieldName]: newValue.inputValue });
    } else {
      onChange(newValue);
    }
  };

  const filterOptions = (options: OptionType[], params: any) => {
    const inputValueLower = params.inputValue.toLowerCase();
    const filtered = options.filter((option) =>
      option?.[fieldName]?.toLowerCase()
        .includes(inputValueLower)
    );

    if (
      params.inputValue &&
      !options.some(
        (opt) =>
          opt?.[fieldName]?.toLowerCase() === inputValueLower
      )
    ) {
      filtered.push({
        inputValue: params.inputValue,
        [fieldName]: `Add "${params.inputValue}"`,
      });
    }

    return filtered;
  };
  return (
    <Box>
      <div className="searchable-free-solo-auto-select-component">
        <FormControl fullWidth error={!!isShowError}>
          <Autocomplete
            value={value}
            onChange={handleChange}
            filterOptions={filterOptions}
            options={options}
            getOptionLabel={getLabel}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            renderOption={(props, option) => {
              const { key, ...otherProps } = props;
              return (
                <li key={key} {...otherProps}>
                  {option[fieldName]}
                </li>
              );
            }}
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={placeholder}
                name={fieldName}
                onBlur={handleBlur}
              />
            )}
            PopperComponent={CustomPopper}
            popupIcon={<ExpandMoreIcon />}
            sx={{
              "& .MuiOutlinedInput-root": {
                paddingRight: 0,
                paddingLeft: "9px",
                padding: 0,
              },
            }}
          />
        </FormControl>
        {isShowError && (
          <ErrorMessage
            name={fieldName}
            component="div"
            className="error-message"
          />
        )}
      </div>
    </Box>
  );
};

export default SearchableFreeSoloAutoSelect;
